<template>
  <div>
    <!--头部 :showValue="1"-->
    <HeaderForPlay ></HeaderForPlay>
    <div class="jqgk" style="background: #fff">
      <div class="contai" style="max-width: 1197px;background:white;padding-left:20px;padding-right:20px;margin-bottom: 20px;">
        <!-- top_tit -->
        <div class="" style="padding-top:20px">

          <div style="display: flex;flex-direction:row;margin-bottom:20px">
             <div class=""  v-for="item in listCaiDan" :key="item.id">
                <img v-if="item.check == true" :src="item.url" @click='check(item.id)'/>
             </div>
          </div>

          <!-- <div class="titleShuXian"  v-if="pcshow"></div>
          <span class="titleFont" v-if="pcshow">{{china}}</span>
          <span class="titleFontEnglish" v-if="pcshow">{{english}}</span> -->

          <!-- <div class="titleShuXianForPhone"  v-if="!pcshow"></div>
          <span class="titleFont" style="font-size:16px" v-if="!pcshow"
            >{{china}}</span
          >
          <span class="titleFontEnglishForPhone" style="font-size:12px" v-if="!pcshow"
            >{{english}}</span
          > -->

          <img :src="cover" />

          <div v-for="item in dataList" :key="item.key">
            <div class="playAll">
              <img :src="item.url" class="playLogo" />
              <div class="palyText">
                <div class="palyTopTitle">
                  {{ item.title }}
                </div>

                <div v-for="item2 in JSON.parse(item.urlList)" :key="item2.key">
                <div style="" v-if="item2.type == 1">
                  {{ item2.content }}
                </div>
                <div style="" v-if="item2.type == 2">
                  <img :src="item2.content" style="width:92%"/>
                </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderForPlay from './headerforplay'
import Footer from './footer'
import { getPlayForFoot, getPlayList, getPlayForFootCover } from '@/api/public'

export default {
  components: { HeaderForPlay, Footer },
  data () {
    return {
      cover: '',
      checkId: 0,
      listCaiDanCopy: [
        {'id': '1', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/a4f08156-c711-4860-ae90-7cf06cacf1f7neiB.png', 'check': true},
        {'id': '5', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/10e00122-a9ee-4177-8355-69d88229ce76neiH.png', 'check': false},
        {'id': '2', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/ac861dd4-d85f-4963-b2b0-f45c86b5da70waiB.png', 'check': true},
        {'id': '6', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/4bda5201-79fe-4d6d-890f-94e2180a8190waiH.png', 'check': false},
        {'id': '3', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/1667654d-e1cd-498b-a350-4aa3630f3f5azhiB.png', 'check': true},
        {'id': '7', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/17006472-574c-420b-9c98-8600a4e96e02zhiH.png', 'check': false},
        {'id': '4', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/44784a0b-fad5-4a83-aa69-1cc5d84eebf7tingB.png', 'check': true},
        {'id': '8', 'url': 'https://www.xiqiaoshantour.com/static/traffic/cn/502c366c-2fbb-49c4-bc25-ce2a4a263e3etingH.png', 'check': false}
      ],
      listCaiDan2: [
        {'id': '1', 'url': 'http://gangmao.oss-cn-shenzhen.aliyuncs.com/yds/neiH.png', 'check': false},
        {'id': '2', 'url': 'http://gangmao.oss-cn-shenzhen.aliyuncs.com/yds/waiH.png', 'check': false},
        {'id': '3', 'url': 'http://gangmao.oss-cn-shenzhen.aliyuncs.com/yds/zhiH.png', 'check': false},
        {'id': '4', 'url': 'http://gangmao.oss-cn-shenzhen.aliyuncs.com/yds/tingH.png', 'check': false}
      ],
      listCaiDan: [
        {'id': '1', 'url': 'https://www.xiqiaoshantour.com/static/online/neiB.png', 'check': true},
        {'id': '5', 'url': 'https://www.xiqiaoshantour.com/static/online/neiH.png', 'check': false},
        {'id': '2', 'url': 'https://www.xiqiaoshantour.com/static/online/waiB.png', 'check': true},
        {'id': '6', 'url': 'https://www.xiqiaoshantour.com/static/online/waiH.png', 'check': false},
        {'id': '3', 'url': 'https://www.xiqiaoshantour.com/static/online/zhiB.png', 'check': true},
        {'id': '7', 'url': 'https://www.xiqiaoshantour.com/static/online/zhiH.png', 'check': false},
        {'id': '4', 'url': 'https://www.xiqiaoshantour.com/static/online/tingB.png', 'check': true},
        {'id': '8', 'url': 'https://www.xiqiaoshantour.com/static/online/tingH.png', 'check': false}
      ],
      china: '',
      english: '',
      dataList: [],
      pcshow: false
    }
  },
  beforeCreate () {},
  created () {
    this.checkId = 1
    this.listCaiDan[this.checkId - 1].check = false
    this.listCaiDan.forEach((item, index) => {
      item.id == (this.checkId + 4) ? (item.check = true) : ''
    })

    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
    this.getList()
    getPlayList().then(response => {
      this.china = response.data.sort(this.compare('sort'))[0].title
      this.english = response.data.sort(this.compare('sort'))[0].enTitle
    })
    this.getCover()
  },
  mounted () {},
  methods: {
    check (id) {
      if (id <= 4) {
        // console.log(JSON.stringify(this.listCaiDan))
        this.listCaiDan = JSON.parse(JSON.stringify(this.listCaiDanCopy))
        this.checkId = id
        this.listCaiDan.forEach((item, index) => {
          (Number(item.id) == (Number(this.checkId) + 4)) ? (item.check = true, this.listCaiDan[index - 1].check = false) : ''
        })
        console.log('this.listCaiDan:', this.listCaiDan)
      }
      // console.log(JSON.stringify(this.listCaiDan))
      this.getList()
      this.getCover()
    },
    getList () {
      getPlayForFoot(this.checkId).then(response => {
        //  var list = JSON.parse(response.data[0].introduce);
        //  this.dataList = list.sort(this.compare("key"));
        this.dataList = response.data
        console.log('this.dataList:', JSON.parse(this.dataList[0].urlList)[0].content)
      })
    },
    getCover () {
      getPlayForFootCover(this.checkId).then(response => {
        this.cover = response.data.typeUrl
      })
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    }
  }
}
</script>

<style>
.palyTopTitle {
  font-size: 15px;
  font-weight: 600;
}
.playAll {
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  border-bottom: #ccc 1px solid;

  padding: 10px 0;
}
.playAll2 {
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  border-bottom: #ccc 1px solid;
  padding: 10px 0;
  height: 210px;
}
.playAll3 {
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  border-bottom: #ccc 1px solid;
  padding: 10px 0;
  height: 190px;
}
.playAll4 {
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  border-bottom: #ccc 1px solid;
  padding: 10px 0;
  height: 280px;
}
.playLogo {
  width: 70px;
  height: 70px;
  padding: 0;
  margin: 0px 10px 10px 10px;
}

.palyText {
  /* height:30px; */
  width: 1053px;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-top: 15px;
}
.smallTitle {
  font-size: 19px !important;
  font-weight: 600 !important;
  width: 100%;
  color: rgb(227 227 227 / 84%) !important;
  text-indent: 2em;
  padding: 0 !important;
}
.widAll {
  width: 100%;
  padding-left: 0px !important;
  font-size: 30px !important;
}
.next-top {
  margin: 40px auto 0 !important;
}
.next-center {
  margin: 0 auto !important;
}
.next-buttom {
  margin: 0 auto 40px !important;
}
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleShuXianForPhone{
  height: 28px;
  margin-top: 14px;
  width: 4px;
  background-color: #840207;
  float: left;
}
.titleFontEnglishForPhone {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 0px;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.titleFont {
  font-size: 33px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}

.titleFontp {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #2c3030;
  line-height: 36px;
  margin: 0px;
  padding: 0px;
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/PlayAllOver.vue